var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchAlterar, fetchCadastrar, fetchResource, fetchConsultarPaginada } from '../../../api';
var ROTA_BASE = 'reeducandos-pontos/fechamento-mensal';
// ---------------------------------------------------------------------------
// Funções de serviço
// ---------------------------------------------------------------------------
/**
 * Busca a listagem de folhas do fiscal local.
 *
 * GET /reeducandos-pontos/fechamento-mensal
 * - Default: mês corrente, 10 por página, ordenação por nome ASC
 * - Retorna contexto_fiscal, filtros_disponiveis e fila_assinaturas
 */
export var getFolhasMensais = function (pagination, filtros) { return __awaiter(void 0, void 0, Promise, function () {
    var params, qs, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = new URLSearchParams();
                if (filtros === null || filtros === void 0 ? void 0 : filtros.nome)
                    params.append('nome', filtros.nome);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.matricula)
                    params.append('matricula', filtros.matricula);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.empresa_cnpj)
                    params.append('empresa_cnpj', filtros.empresa_cnpj);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.status)
                    params.append('status', filtros.status);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.ano_referencia)
                    params.append('ano_referencia', String(filtros.ano_referencia));
                if (filtros === null || filtros === void 0 ? void 0 : filtros.mes_referencia)
                    params.append('mes_referencia', String(filtros.mes_referencia));
                if (filtros === null || filtros === void 0 ? void 0 : filtros.data_inicio)
                    params.append('data_inicio', filtros.data_inicio);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.data_fim)
                    params.append('data_fim', filtros.data_fim);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.sort_by)
                    params.append('sort_by', filtros.sort_by);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.sort_order)
                    params.append('sort_order', filtros.sort_order);
                qs = params.toString();
                url = "".concat(ROTA_BASE).concat(qs ? '?' + qs : '');
                return [4 /*yield*/, fetchConsultarPaginada(url, pagination)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Assina e envia a folha à FUNAC.
 *
 * PATCH /reeducandos-pontos/fechamento-mensal/:id/assinar-e-enviar
 */
export var assinarEEnviarFolha = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/").concat(id, "/assinar-e-enviar");
                return [4 /*yield*/, fetchAlterar(url, { senha_validada: true })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var assinarEEnviarFolhasEmLote = function (folhasIds, senhaValidada, periodo) { return __awaiter(void 0, void 0, Promise, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/assinar-em-lote");
                return [4 /*yield*/, fetchCadastrar(url, __assign({ folhas_ids: folhasIds, senha_validada: senhaValidada }, ((periodo === null || periodo === void 0 ? void 0 : periodo.data_inicio) && (periodo === null || periodo === void 0 ? void 0 : periodo.data_fim) ? periodo : {})))];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
/**
 * Reenvia folha devolvida para correção.
 *
 * PATCH /reeducandos-pontos/fechamento-mensal/:id/reenviar
 */
export var reenviarFolha = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/").concat(id, "/reenviar");
                return [4 /*yield*/, fetchAlterar(url, {})];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Busca o detalhamento (espelho mensal) de uma folha.
 *
 * GET /reeducandos-pontos/fechamento-mensal/:id
 */
export var getDetalhamentoFolha = function (id, periodo) { return __awaiter(void 0, void 0, Promise, function () {
    var params, qs, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = new URLSearchParams();
                if ((periodo === null || periodo === void 0 ? void 0 : periodo.data_inicio) && (periodo === null || periodo === void 0 ? void 0 : periodo.data_fim)) {
                    params.append('data_inicio', periodo.data_inicio);
                    params.append('data_fim', periodo.data_fim);
                }
                qs = params.toString();
                url = "".concat(ROTA_BASE, "/").concat(id).concat(qs ? '?' + qs : '');
                return [4 /*yield*/, fetchResource(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Busca o detalhamento de uma justificativa no contexto do fechamento mensal.
 *
 * GET /reeducandos-pontos/fechamento-mensal/:folhaId/justificativas/:justificativaId
 * - Rota read-only, day-centric
 * - Retorna cabecalho, resultado, descricao, tramitacao e documento_anexado (quando houver)
 */
export var getJustificativaFolha = function (folhaId, justificativaId) { return __awaiter(void 0, void 0, Promise, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/").concat(folhaId, "/justificativas/").concat(justificativaId);
                return [4 /*yield*/, fetchResource(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
